import { uploadResponseSchema, uploadStatusSchema, type UploadRequest, type UploadResponse, type UploadStatus } from '@painpal/contracts';
import { ApiRequestError, apiJson } from '../lib/api';

export function requestUploads(files: File[]): Promise<UploadResponse> {
  const body: UploadRequest = { files: files.map((file) => ({ name: file.name, size: file.size })) };
  return apiJson('/api/uploads', uploadResponseSchema, { method: 'POST', json: body });
}

export async function putFile(url: string, file: File): Promise<void> {
  const response = await fetch(url, { method: 'PUT', body: file, headers: { 'Content-Type': 'application/octet-stream' } });
  if (!response.ok) throw new ApiRequestError(response.status, 'upload_failed', `Upload failed (${response.status})`);
}

export function fetchUploadStatus(key: string): Promise<UploadStatus> {
  return apiJson(`/api/uploads/${encodeURIComponent(key)}`, uploadStatusSchema);
}
